import { Alert, Button, Modal, Spin, Typography } from "antd";
import React from "react";
import { apiErrorMessage, useNoticeEmail } from "./api";
import { formatUkDateTime } from "./lib";

export interface OriginalEmailModalProps {
  /** The notice whose stored email to show; null keeps the window closed and sends no request. */
  noticeId: number | null;
  onClose: () => void;
}

/** The read-only "Original email" window of a notice (spec 11.1 and 11.3). */
export const OriginalEmailModal: React.FC<OriginalEmailModalProps> = ({
  noticeId,
  onClose,
}) => {
  const { data: email, isLoading, isError, error } = useNoticeEmail(noticeId);

  return (
    <Modal
      open={noticeId !== null}
      title="Original email"
      onCancel={onClose}
      footer={<Button onClick={onClose}>Close</Button>}
      width={760}
    >
      <Typography.Paragraph type="secondary">
        Kept with the notice, read-only.
      </Typography.Paragraph>
      {isLoading && <Spin />}
      {isError && (
        <Alert type="error" showIcon message={apiErrorMessage(error)} />
      )}
      {email && (
        <>
          <Typography.Paragraph strong style={{ marginBottom: 4 }}>
            {email.subject}
          </Typography.Paragraph>
          <Typography.Paragraph type="secondary">
            {formatUkDateTime(email.emailDate)}
          </Typography.Paragraph>
          <pre
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              maxHeight: 480,
              overflow: "auto",
              fontSize: 12,
              margin: 0,
            }}
          >
            {email.rawText}
          </pre>
        </>
      )}
    </Modal>
  );
};
